import Vue from 'vue'

import NotFound from './pages/NotFound';
Vue.component("not-found", NotFound);